import t from "styled-components";
import { Modal as o } from "./atoms-v226.js";
import { breakpoints as i } from "./atoms-v2125.js";
import { Button as p } from "./atoms-v26.js";
import { TextInput as e } from "./atoms-v244.js";
const a = t.div`
  display: flex;
  flex-direction: column;
`;
t(o.Content)`
  flex-direction: column;
  padding: 0;
`;
t(o.Wrapper)`
  height: auto;
  width: 520px;
`;
const l = t.div`
  box-sizing: border-box;
  display: flex;
  gap: 8px;
  padding: 24px;
`, f = t(p)`
  height: 44px;
  width: 44px;

  @media ${i.medium} {
    height: 56px;
    width: 56px;
  }
`, h = t(e)`
  flex: 1;
`;
export {
  l as CVVContainer,
  h as CvvInput,
  f as SaveButton,
  a as Wrapper
};
